import { nodeAxiosInstance } from "./axiosInstance";
import { ResponseType } from "axios";

type RequestMethod = "GET" | "POST" | "PUT" | "DELETE" | "PATCH";

interface ApiOptions {
  method?: RequestMethod;
  body?: Record<string, any>;
  headers?: Record<string, string>;
  params?: Record<string, string | number>;
  responseType?: ResponseType;
}

const nodeApi = async <T>(endpoint: string, options: ApiOptions = {}): Promise<T> => {
  const {
    method = "GET",
    body,
    headers = {},
    params,
    responseType,
  } = options;

  const finalHeaders: Record<string, string> = { ...headers };

  // Only set Content-Type if body is NOT FormData
  if (body && !(body instanceof FormData)) {
    finalHeaders["Content-Type"] = "application/json";
  }

  try {
    const response = await nodeAxiosInstance.request<T>({
      url: endpoint,
      method,
      data: body,
      headers: finalHeaders,
      params,
      responseType,
    });
    return response.data;
  } catch (error: any) {
    throw error;
  }
};

export default nodeApi;